import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import type { Adapter } from 'modules/core/lib/mobx-rest/types'
import app from 'modules/core/store/models/app'

interface Props {
  api: Adapter
  legalEntityId: string
  importMode?: string
  downloadPath: string
  checkDownload?: string
}

const useDownloadFile = ({
  api,
  legalEntityId,
  importMode,
  downloadPath,
  checkDownload,
}: Props) => {
  const { running, performAction: onSubmit } = useAsyncAction(
    async () => {
      let apiURL = `${checkDownload}/${legalEntityId}`
      if (importMode) apiURL += `/${importMode}`

      const response = checkDownload ? await api.get(apiURL) : null

      // Download the template directly to the browser if:
      // 1. We're not checking in the backend if the download is available
      // 2. We're checking in the backend if the download is available and it's true
      if (!checkDownload || (checkDownload && response.result)) {
        let url = `${downloadPath}/${legalEntityId}`

        if (importMode) url += `/${importMode}`

        window.location.href = buildUrl(url)
        // Send the template by email if we're checking in the backend if the download is available and it's false
      } else {
        app.setFlash({
          type: 'correct',
          message: i18n.t('employees.export_template_by_email'),
        })
      }
    },
    {
      successFlash: false,
    }
  )
  return {
    running,
    onSubmit,
  }
}
export default useDownloadFile
